import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {message, Breadcrumb, Form, Row, Col, Input, DatePicker, Space, Button} from "antd";
import {LeftCircleOutlined, FileDoneOutlined} from "@ant-design/icons";
import moment from "moment";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Detail.module.css";

const MemberBenefitDetail = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [systemVersion, setSystemVersion] = useState(0);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/member/benefit/index"});

            switch (props.match.path) {
                case "/member/benefit/add":
                    setIsSave(true);

                    break;
                case "/member/benefit/edit/:memberBenefitId":
                    setIsEdit(true);

                    handleLoadMemberBenefit();

                    break;
                default:
                    break;
            }
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    const handleLoadMemberBenefit = () => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/member/benefit/business/website/v1/find",
            data: {
                memberBenefitId: props.match.params.memberBenefitId,
            },
            success: (response) => {
                response.data.memberBenefitStart = moment(response.data.memberBenefitStart, "YYYY-MM-DD HH:mm");
                response.data.memberBenefitEnd = moment(response.data.memberBenefitEnd, "YYYY-MM-DD HH:mm");

                form.setFieldsValue(response.data);

                setSystemVersion(response.data.systemVersion);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        typeof response.data.memberBenefitId == "undefined" ||
                        response.data.memberBenefitId == null
                );
            },
        });
    };

    const handleSubmitMemberBenefit = () => {
        if (request.current) {
            return;
        }

        form.validateFields()
            .then((data) => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                data.memberBenefitId = props.match.params.memberBenefitId;
                data.memberBenefitStart = data.memberBenefitStart.format("YYYY-MM-DD HH:mm");
                data.memberBenefitEnd = data.memberBenefitEnd.format("YYYY-MM-DD HH:mm");
                data.systemVersion = systemVersion;

                let url = "";
                if (isSave) {
                    url = "/windeal/member/benefit/business/website/v1/save";
                }
                if (isEdit) {
                    url = "/windeal/member/benefit/business/website/v1/update";
                }

                ChuangShiOS.Util.request(props, {
                    url: Application.host + url,
                    data: data,
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);

                        ChuangShiOS.Util.navigateBack(props, {});
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            })
            .catch((response) => {
                ChuangShiOS.Util.parseResponseError(response);
            });
    };

    const handleBackMemberBenefit = () => {
        ChuangShiOS.Util.navigateBack(props, {});
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<LeftCircleOutlined />} size="large" onClick={handleBackMemberBenefit}>
                                返回
                            </Button>
                        </Button.Group>
                        <Button
                            loading={isLoad}
                            disabled={isError}
                            icon={<FileDoneOutlined />}
                            type="primary"
                            size="large"
                            onClick={handleSubmitMemberBenefit}
                        >
                            提交
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content
                className={Style.content}
                isLoad={isLoad}
                isEmpty={false}
                isError={isError}
                paddingTop={28}
                isScroll={store.main.isFixedContent}
            >
                <Row>
                    <Col flex="auto">
                        <div className={Style.card_title}>基本信息</div>
                    </Col>
                    <Col></Col>
                </Row>
                <Form form={form}>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="会员编号"
                                name="memberId"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入会员编号",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入会员编号" onPressEnter={handleSubmitMemberBenefit} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="权益编号"
                                name="benefitId"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入权益编号",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入权益编号" onPressEnter={handleSubmitMemberBenefit} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="权益编号"
                                name="benefitCodeId"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入权益编号",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入权益编号" onPressEnter={handleSubmitMemberBenefit} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="权益代码"
                                name="benefitCode"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入权益代码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入权益代码" onPressEnter={handleSubmitMemberBenefit} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="分类列表"
                                name="memberBenefitCategoryList"
                                initialValue={""}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入分类列表",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入分类列表" onPressEnter={handleSubmitMemberBenefit} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="开始时间"
                                name="memberBenefitStart"
                                rules={[
                                    {
                                        required: true,
                                        type: "object",
                                        message: "请选择开始时间",
                                    },
                                ]}
                            >
                                <DatePicker
                                    className={Style.card_field}
                                    showTime={{format: "HH:mm"}}
                                    format="YYYY-MM-DD HH:mm"
                                    placeholder="请输入开始时间"
                                    onPressEnter={handleSubmitMemberBenefit}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "24%"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="结束时间"
                                name="memberBenefitEnd"
                                rules={[
                                    {
                                        required: true,
                                        type: "object",
                                        message: "请选择结束时间",
                                    },
                                ]}
                            >
                                <DatePicker
                                    className={Style.card_field}
                                    showTime={{format: "HH:mm"}}
                                    format="YYYY-MM-DD HH:mm"
                                    placeholder="请输入结束时间"
                                    onPressEnter={handleSubmitMemberBenefit}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

MemberBenefitDetail.propTypes = {};

MemberBenefitDetail.defaultProps = {};

export default MemberBenefitDetail;
